<template>
  <div class="c-action-interest">
    <div v-show="action" class="c-action-line">
      <span>在</span>
      <el-select v-model="action_scene" multiple collapse-tags placeholder="所有行为场景" style="width: 220px">
        <el-option v-for="scene in scenes" :key="scene.key" :value="scene.key" :label="scene.label"> </el-option>
      </el-select>
      <span>中，选择用户</span>
      <el-select v-model="action_days" style="width: 80px">
        <el-option v-for="(day, idx) in days" :key="day" :value="idx" :label="`${day}天`"> </el-option>
      </el-select>
      <span>内发生的行为，行为强度为</span>
      <el-select v-model="strengthType" collapse-tags placeholder="选择行为强度" style="width: 160px">
        <el-option v-for="inten in intensity" :key="inten.key" :value="inten.key" :label="inten.label"> </el-option>
      </el-select>
      <span>：</span>
    </div>

    <div v-show="!action" class="c-action-line">
      <span>意向强度为</span>
      <el-select v-model="strengthType" collapse-tags placeholder="选择行为强度" style="width: 160px">
        <el-option v-for="inten in intensity" :key="inten.key" :value="inten.key" :label="inten.label"> </el-option>
      </el-select>
    </div>
    <div class="c-action-content">
      <Row>
        <Col span="16" class-name="c-action-category">
          <Tabs v-model="tagType" :animated="false">
            <TabPane label="添加类目词" name="category">
              <category-select
                v-model="mult_category"
                :loading="loading"
                :data="categories"
                :recommons="recommons"
                :words="words"
                :query-word="queryWord"
                :complete-data="autoData"
                :placeholder="categoryPlaceholder"
                :disabled="disabled"
                :action="action"
                @on-more="handleMore"
                @on-complete="searchCategory"
                @on-search="queryRecommon"
                @on-select="selectKeyword"
                @on-clear="recommons = []"
                @on-cancel="cannelHandle"
              />
            </TabPane>
            <TabPane label="添加关鍵词" name="keyword" v-if="action">
              <keyword-select
                v-model="keyword"
                :data="keywords"
                :words="words"
                :complete-data="completeData"
                :loading="quering"
                :placeholder="queryPlaceholder"
                :disabled="disabled"
                @on-complete="searchKeyword"
                @on-search="queryKeyword"
                @on-select="selectKeyword"
                @on-cancel="cannelHandle"
              />
            </TabPane>
          </Tabs>
        </Col>
        <Col span="7" offset="1">
          <action-result
            :value="actions"
            :title="tagName"
            :loading="loading"
            :max="max"
            sub-title
            @on-search="queryKeyword"
            @on-delete="delTag"
            @on-clear="clearTag"
          />
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { isArray, findCheck, getKeyOfData, clearTagOfData } from '@/common/js/utils'
import { DAYS, SCENE, STRONG } from './data'
import { getBehaviorAndInterest, queryKeyword } from '@/api/kuaishou.model'

import CategorySelect from './select/category'
import KeywordSelect from './select/keyword'
import ActionResult from './result/result'

// 子集
const findChild = (data) => {
  return data.reduce((childs, ret) => {
    childs.push(ret)
    if (ret.children) childs = childs.concat(findChild(ret.children))
    return childs
  }, [])
}

// 所有子集
const getCheckId = (item, data) => {
  if (!isArray(item)) return []
  return item.reduce((ids, ret) => {
    const cat = findChild(data)
      .filter((m) => ret.id === m.id)
      .pop()
    ids.push(ret.id)
    if (ret.children) ids = ids.concat(getCheckId(ret.children, data))
    else if (cat && isArray(cat.children)) ids = ids.concat(getCheckId(cat.children, data))
    return ids
  }, [])
}
export default {
  name: 'actionInterest',
  components: {
    CategorySelect,
    KeywordSelect,
    ActionResult
  },
  props: {
    value: {
      type: Array
    },
    action: {
      type: Boolean
    },
    accounts: {
      type: Array
    },
    actionScene: {
      type: Array
    },
    actionDays: {
      type: Number
    },
    strength: {
      type: Number
    },
    max: {
      type: Number
    },
    taskId: Number
  },
  computed: {
    action_days: {
      get() {
        return this.actionDays || 0
      },
      set(val) {
        this.$emit('on-days', val)
      }
    },
    action_scene: {
      get() {
        return this.actionScene || []
      },
      set(val) {
        if (!val.length) {
          this.$Message.info('行为场景至少有一个选项！')
          return
        }
        this.$emit('on-scene', val)
      }
    },
    strengthType: {
      get() {
        return this.strength || 0
      },
      set(val) {
        this.$emit('on-intensity', val)
      }
    },
    tagName() {
      return this.action ? '行为' : '兴趣'
    },
    categoryPlaceholder() {
      return `请输入${this.tagName}类目词`
    },
    queryPlaceholder() {
      return `请输入${this.tagName}类目词或关键词`
    },
    postActionScene() {
      return isArray(this.action_scene) && !this.action_scene.length
        ? this.scenes.map((ret) => ret.key).join(',')
        : this.action_scene.join(',')
    },
    account() {
      const [account] = this.accounts || []
      return account.id
    },
    mult_category() {
      return findCheck(this.categories)
    },
    actions() {
      const categoryActions = this.mult_category.map((ret) => Object.assign(ret, { type: 'CATEGORY', id: ret.key, name: ret.value }))
      const keywordActions = this.words.map((ret) => Object.assign(ret, { type: 'KEYWORD' }))
      return [...keywordActions, ...categoryActions]
    },
    disabled() {
      return this.actions.length >= this.max
    }
  },
  methods: {
    proLoadData() {
      // 回调
      const fnCallback = (behavior_interest) => {
        this.loading = true
        if (!behavior_interest) return
        const { behavior, interest } = behavior_interest
        const data = this.action ? behavior : interest
        if (isArray(data)) {
          const defaultActions = isArray(this.value) && this.value.filter((ret) => ret.type.toLowerCase() === 'category') // 类目已选
          const defaultWords = isArray(this.value) && this.value.filter((ret) => ret.type.toLowerCase() === 'keyword') // 关键词
          const defaultActionIds = getCheckId(defaultActions, data) // 类目id
          const mapCategroy = (ret) => {
            // 初始化数据
            const checkState = defaultActionIds.includes(ret.id)
            const cate = {
              id: ret.id,
              key: ret.id,
              value: ret.name,
              name: ret.name,
              check: checkState,
              num: ret.num,
              type: ret.type,
              level: ret.level,
              _time: ret._time
            }
            if (ret.children) {
              return Object.assign({}, cate, {
                children: ret.children.map(mapCategroy)
              })
            } else {
              return cate
            }
          }
          // 还原选中值
          this.categories = data.map(mapCategroy)
          this.words = isArray(defaultWords) ? defaultWords : []
        }
      }
      const params = { ad_account_id: this.account }
      getBehaviorAndInterest(params).then(fnCallback)
    },
    queryKeyword(filter) {
      let params = { ad_account_id: this.account }
      if (this.tagType !== 'keyword') this.tagType = 'keyword'
      this.keyword = filter.name
      if (filter) params = Object.assign(params, { keyword: filter.name })
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 开始请求关键词
      this.quering = true
      queryKeyword(params).then((data) => {
        this.quering = false
        if (isArray(data)) {
          this.keywords = data
        }
      })
    },
    queryRecommon(filter) {
      let params = { ad_account_id: this.account }
      if (filter) params = Object.assign(params, { keyword: filter.name })
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      queryKeyword(params).then((data) => {
        if (data) {
          this.queryWord = filter.name
          this.recommons = data
        }
      })
    },
    searchKeyword(query) {
      const params = {
        ad_account_id: this.account,
        keyword: query
      }
      const fnCallback = (data) => {
        isArray(data) && this.canning && (this.completeData = data)
      }
      this.canning = true
      queryKeyword(params).then(fnCallback)
    },
    searchCategory(query) {
      const params = {
        ad_account_id: this.account,
        keyword: query
      }
      const fnCallback = (data) => {
        isArray(data) && this.canning && (this.autoData = data)
      }
      this.canning = true
      queryKeyword(params).then(fnCallback)
    },
    cannelHandle(type) {
      this.canning = false
      if (type === 'gategory') this.autoData = []
      else this.completeData = []
    },
    handleMore() {
      this.queryKeyword({
        name: this.queryWord,
        tag_type: 'CATEGORY'
      })
    },
    // 批量加入关键词
    selectKeyword(items) {
      if (!isArray(items)) return
      const invaild = this.max - this.actions.length
      const word_ids = JSON.parse(JSON.stringify(this.words)).map((ret) => ret.id)
      const push_items = items
        .filter((ret, id) => id < invaild && !word_ids.includes(ret.id))
        .map((ret) => Object.assign(ret, { _time: Date.now() }))
      this.words.push(...push_items)
    },
    // 删除已选
    delTag(item) {
      const { id, type } = item
      if (type === 'CATEGORY') {
        const data = getKeyOfData(this.categories, 'key', id)
        const delCheck = (item) => {
          if (item.children && item.children.length) {
            item.children.forEach((ret) => {
              delCheck(ret)
            })
          }
          this.$set(item, 'check', false)
        }
        delCheck(data)
      } else {
        const idx = this.words.findIndex((ret) => ret.id === id)
        if (idx > -1) this.words.splice(idx, 1)
      }
    },
    // 清空全部
    clearTag() {
      clearTagOfData(this.categories, this)
      this.words = []
    }
  },
  data() {
    return {
      canning: null, // 取消状态
      loading: null, // 数据请求状态
      words: [], // 已选关键词
      categories: [], // 类目数据
      recommons: [], // 相关推荐结果
      queryWord: '', // 相关推荐词
      quering: null, // 请求关键词状态
      keyword: '', // 添加关键词
      keywords: [], // 关键词数据
      completeData: [], // 关键词下拉模糊搜索数据源
      autoData: [], // 类目下拉数据源
      tagType: 'category',
      days: DAYS,
      scenes: SCENE,
      intensity: STRONG
    }
  },
  watch: {
    taskId() {
      // 监控任务id变化重新渲染数据
      this.proLoadData()
    },
    actions: {
      handler(nVal) {
        this.$emit('input', nVal)
      },
      deep: true
    }
  },
  created() {
    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-action-interest {
  position: relative;

  .c-action-line {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    span {
      padding: 0 6px;

      &:first-child {
        padding-left: 0;
      }
    }
  }

  ::v-deep .c-action-content {
    .c-action-category {
      border: solid 1px #dee4f5;

      .c-tabs-content {
        padding: 0 8px 10px 8px;
      }

      .c-action-search {
        margin-bottom: 16px;
      }
    }
  }

  ::v-deep .el-input {
    .el-input__inner,
    .el-input__icon {
      height: 30px;
      line-height: 30px;
    }
  }

  ::v-deep .ivu-tabs-nav {
    margin-left: 10px;

    .ivu-tabs-tab {
      padding: 15px 16px;
    }
  }
}
</style>
